import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accounts"];
import { combineReducers } from 'redux';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as RequestStatus from 'automation-ui-canvas/constants/RequestStatus';
import AdAccountRecord from 'automation-ui-action-features/actions/ads-audience-membership/AdAccountRecord';
const INITIAL_AD_ACCOUNT_STATE = {
  value: null,
  requestStatus: RequestStatus.UNINITIALIZED
};
const adAccounts = (state = INITIAL_AD_ACCOUNT_STATE, action) => {
  switch (action.type) {
    case ActionTypes.ADS_REQUESTED_AD_ACCOUNTS:
      {
        return Object.assign({}, state, {
          requestStatus: RequestStatus.PENDING
        });
      }
    case ActionTypes.ADS_REQUESTED_AD_ACCOUNTS_FAILED:
      {
        return Object.assign({}, state, {
          requestStatus: RequestStatus.FAILED
        });
      }
    case ActionTypes.ADS_RECEIVED_AD_ACCOUNTS:
      {
        const _action$payload = action.payload,
          {
            overview: {
              accounts
            },
            permissions
          } = _action$payload,
          value = _objectWithoutPropertiesLoose(_action$payload.overview, _excluded);
        return {
          value: Object.assign({
            accounts: accounts.map(account => {
              const accountPermissions = permissions.find(perm => perm.adNetwork === account.network && perm.adAccountId === account.accountId);
              return new AdAccountRecord(Object.assign({}, account, accountPermissions ? accountPermissions.permissions : {}, {
                currentUserHasConnected: !!accountPermissions
                // TODO: Incompatible types for constructor
              }));
            })
          }, value),
          requestStatus: RequestStatus.SUCCEEDED
        };
      }
    default:
      {
        return state;
      }
  }
};
const INITIAL_USAGE_STATE = {
  value: null,
  requestStatus: RequestStatus.UNINITIALIZED
};
const audienceUsage = (state = INITIAL_USAGE_STATE, action) => {
  switch (action.type) {
    case ActionTypes.ADS_REQUESTED_AUDIENCE_USAGE:
      {
        return Object.assign({}, state, {
          requestStatus: RequestStatus.PENDING
        });
      }
    case ActionTypes.ADS_REQUESTED_AUDIENCE_USAGE_FAILED:
      {
        return Object.assign({}, state, {
          requestStatus: RequestStatus.FAILED
        });
      }
    case ActionTypes.ADS_RECEIVED_AUDIENCE_USAGE:
      {
        const {
          networkAudienceSourceCounts
        } = action.payload;
        const contactListAudienceCount = Object.keys(networkAudienceSourceCounts).reduce((count, network) => count + (networkAudienceSourceCounts[network].HUBSPOT_CONTACT_LIST || 0), 0);
        return {
          value: contactListAudienceCount,
          requestStatus: RequestStatus.SUCCEEDED
        };
      }
    default:
      {
        return state;
      }
  }
};
const adsReducer = combineReducers({
  adAccounts,
  audienceUsage
});
export default adsReducer;